import React, { Component } from "react";

import PropTypes from "prop-types";
import ReactJWPlayer from "react-jw-player";

import { appContentUrl, storageKeys } from "settings";
import {
  SharingPopup,
  ShareButton,
  DataHandler,
  StorageHandler,
  APIHandler,
} from "C4";

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      const email =
        userObj && userObj.response.email ? userObj.response.email : "Guest";
      APIHandler.trackEvent(appId, email, "videos", type, value, title);
    });
  });
};

export default class TrainingVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      qualityIndex: 0,
      quality: [
        { name: "720", hash: "kTA1qc4f" },
        { name: "406", hash: "DA7zOnMs" },
        { name: "270", hash: "2oBCa4mK" },
        { name: "180", hash: "YnNQqrRg" },
      ],
    };
  }

  render() {
    const { image, linkJW1, appId, contentComplete, minTime, autoPlay, title } =
      this.props;

    const { qualityIndex, quality } = this.state;

    return (
      <div style={{ position: "relative" }}>
        <ReactJWPlayer
          playerId="video-player"
          playerScript="https://content.jwplatform.com/libraries/gj8NKibk.js"
          file={`https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`}
          image={`${appContentUrl}${appId}/${image}`}
          isAutoPlay={autoPlay}
          onComplete={contentComplete}
          onTime={(e) => {
            if (e.duration >= minTime && e.position >= minTime) {
              contentComplete();
            }
          }}
          onReady={() => {
            trackShare(
              "videos",
              `https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`,
              title,
            );
          }}
          onError={(e) => {
            console.error(e);
            contentComplete();
            if (qualityIndex < quality.length - 1) {
              this.setState({ qualityIndex: qualityIndex + 1 });
            }
          }}
        />
        <ShareButton
          dataFancyboxTrigger="shareJW"
          title="Share this Video"
          data-fancybox
          dataSource="#shareJW"
          className="trainingContent__shareBtn"
        />
        <SharingPopup
          url={`https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`}
          triggerId="shareJW"
        />
      </div>
    );
  }
}

TrainingVideo.propTypes = {
  linkJW1: PropTypes.string.isRequired,
  image: PropTypes.string,
  minTime: PropTypes.number,
  autoPlay: PropTypes.bool,
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  title: PropTypes.string,
};

TrainingVideo.defaultProps = {
  autoPlay: true,
  image: "",
  minTime: 30,
  contentComplete: () => {},
  title: "",
};
